import { DOMAIN_LABELS } from '@/types/contextEngine'
import { DOMAIN_ICONS } from '@/components/context/domainIcons'
import { useContextEngineStore } from '@/stores/contextEngineStore'
import type { ContextDomain } from '@/types/contextEngine'

interface DomainContextHeaderProps {
  domain: ContextDomain
  gapId?: string | null
}

export function DomainContextHeader({ domain, gapId }: DomainContextHeaderProps) {
  const Icon = DOMAIN_ICONS[domain]
  const label = DOMAIN_LABELS[domain]
  const gapAnalysis = useContextEngineStore((s) => s.gapAnalysis)

  const domainScore = gapAnalysis?.domainScores.find((d) => d.domain === domain)
  const gap = gapId ? gapAnalysis?.gaps.find((g) => g.gapId === gapId) : null

  return (
    <div className="mb-6 rounded-lg border border-accent-amber/20 bg-accent-amber/5 p-4">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-amber/10">
          <Icon size={20} className="text-accent-amber" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="font-display text-sm font-semibold text-text-primary">
              {label}
            </span>
            {domainScore && (
              <span className="font-mono text-xs text-accent-amber">
                {Math.round(domainScore.score)}%
              </span>
            )}
          </div>
          {gap && (
            <p className="mt-0.5 text-xs text-text-secondary">{gap.description}</p>
          )}
          {!gap && (
            <p className="mt-0.5 text-xs text-text-secondary">
              Adding context to {label.toLowerCase()}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
